module.exports = __webpack_public_path__ + "media/advisor.bc156f2a.mp4";